function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M46.198 14H24.106c-1.09 0-2.134.406-2.904 1.127A3.725 3.725 0 0020 17.846v42.309c0 .505.106 1.005.312 1.472.207.466.51.89.89 1.247.382.357.835.64 1.333.834a4.35 4.35 0 001.573.292h29.784c1.09 0 2.135-.405 2.905-1.126A3.725 3.725 0 0058 60.154V25.048L46.198 14z",
  fill: "#FBE696"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M25.667 20.906h25.714M25.667 27.573h25.714",
  stroke: "#938666",
  strokeWidth: 3,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M25.667 53.287h12.38M25.667 56.144h12.38M25.667 59.002h12.38",
  stroke: "#938666",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M51.286 52.335h-8.381a2 2 0 00-2 2v3.619a2 2 0 002 2h8.381a2 2 0 002-2v-3.62a2 2 0 00-2-2z",
  fill: "#938666"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M46 14v6.112c0 .642.138 1.278.405 1.87.268.594.66 1.133 1.155 1.586a5.386 5.386 0 001.73 1.06 5.75 5.75 0 002.04.372H58L46 14z",
  fill: "#FFE"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M51.286 31.382H26.715a2 2 0 00-2 2V48.43a2 2 0 002 2h24.571a2 2 0 002-2V33.382a2 2 0 00-2-2z",
  fill: "#C2CC4C"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M48.318 45.726a.751.751 0 00-.508-.194c-.19 0-.373.07-.509.194a1.907 1.907 0 01-.618.383c-.232.089-.48.134-.731.133a1.99 1.99 0 01-.63-.1c0-1.456-.504-4.758-5.723-5.215a3.678 3.678 0 01-.243-1.298c.006-.387.063-.773.17-1.148.294-.071.597-.105.9-.1.9 0-.08-1.364.289-1.563.575-.308.638 1.248.9 1.248.26 0 .773 0 .9-.308.125-.308-.577-1.248 0-1.248.575 0 .287 1.248.9 1.248h1.448c1.197 0-1.43-3.743-4.427-2.188-.442.19-.816.494-1.077.874-.262.38-.4.822-.4 1.272a2.854 2.854 0 00-.692-1.307 3.186 3.186 0 00-1.287-.839c-3.023-1.247-6.119 2.196-4.706 2.196h1.683c.675 0 .342-1.247 1.017-1.247.674 0-.342 1.247 0 1.247a1.9 1.9 0 011.007.308c.342.316.342-1.555 1.017-1.248.423.2-.675 1.564.333 1.564.385-.011.77.028 1.143.116a7.522 7.522 0 00-1.062 2.404c-6.119.366-6.299 4.284-6.182 5.332h-.153c-.25.001-.499-.044-.73-.133a1.908 1.908 0 01-.62-.383.755.755 0 00-.5-.172.75.75 0 00-.492.195.642.642 0 00-.21.454.637.637 0 00.186.463c.627.58 1.479.906 2.366.906.888 0 1.74-.326 2.367-.906.177-.164.387-.294.619-.383a2.043 2.043 0 011.461 0c.232.089.442.22.62.383.31.288.679.516 1.085.672.406.155.841.235 1.281.235a3.52 3.52 0 001.283-.231 3.311 3.311 0 001.084-.676 2 2 0 011.35-.514 2 2 0 011.35.514c.627.58 1.478.906 2.366.906.887 0 1.739-.326 2.366-.906a.642.642 0 00.215-.468.64.64 0 00-.206-.472z",
  fill: "#5E4537"
});

var SvgAppiconNewspaper = function SvgAppiconNewspaper(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 76 76",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAppiconNewspaper, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/appicon-newspaper.13ed6fbd.svg";
export { ForwardRef as ReactComponent };